import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const IMAGES = [
    {
        src: "https://customer-assets.emergentagent.com/job_caribbean-premium/artifacts/268snciq_4B00982C-BDB8-4044-BB1B-7B7FE2243CA8.PNG",
        alt: "Empire Jamaica Fusion dining room — warm burgundy walls, candlelit tables, intimate seating",
        span: "md:col-span-6 md:row-span-2 aspect-square md:aspect-[4/5]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_caribbean-premium/artifacts/algcp3ha_04DCB600-D055-49ED-AC04-941FD249AA1D.PNG",
        alt: "Empire Jamaica Fusion ribbon-cutting ceremony at 385 Main Street, Poughkeepsie",
        span: "md:col-span-6 aspect-[4/3]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/wfwhbttq_20E119FE-48F8-4837-A259-B87021DF969B.PNG",
        alt: "Empire Jamaica Fusion braised oxtail in rich gravy with butter beans, rice and peas",
        span: "md:col-span-3 aspect-square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_caribbean-premium/artifacts/lldhlwvh_4D544B4D-5ED1-4118-B68A-2CABF55656D8%202.PNG",
        alt: "Empire Jamaica Fusion catering buffet — Jamaican entrées, sides, floral centerpiece, fruit punch dispenser",
        span: "md:col-span-3 aspect-square",
    },
];

export default function Gallery() {
    return (
        <section
            id="gallery"
            data-testid="gallery-section"
            className="relative empire-section bg-charcoal-800"
            aria-label="Gallery"
        >
            <div className="empire-container">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
                    <div>
                        <p className="empire-eyebrow">In The Room</p>
                        <h2
                            data-testid="gallery-heading"
                            className="mt-5 empire-subhead text-cream"
                        >
                            A cinematic look<br />
                            <span className="italic text-gold">into our world.</span>
                        </h2>
                    </div>
                    <Link
                        to="/gallery"
                        data-testid="gallery-view-all"
                        className="empire-link inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.24em]"
                    >
                        View Full Gallery <ArrowUpRight size={14} />
                    </Link>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-12 gap-2 md:gap-3">
                    {IMAGES.map((img, i) => (
                        <motion.div
                            key={i}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{
                                duration: 0.8,
                                delay: i * 0.08,
                                ease: [0.22, 1, 0.36, 1],
                            }}
                            data-testid={`gallery-tile-${i}`}
                            className={`group relative overflow-hidden ${img.span}`}
                        >
                            <img
                                src={img.src}
                                alt={img.alt}
                                loading="lazy"
                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-[1.08]"
                            />
                            <div className="absolute inset-0 bg-charcoal/20 group-hover:bg-charcoal/0 transition-colors duration-500" />
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
